<template>
  <TsMedia :id="randomId" :data-testid="props.dataTestid" rootClass="block"
           :appendClass="twMerge(props.reverseLayout && 'flex-row-reverse ', 'lg:max-w-max border bg-natural-soft-white rounded-lg flex-1 overflow-hidden',props.appendClass)">
    <TsMediaStart :appendClass="twMerge('flex-1',props.reverseLayout && 'mr-0') ">
      <TsImage v-if="props && props.img" class="h-full"
               :height="props.height"
               :width="props.width" :src="props.img"
               :alt="props.altText" data-testid="img" loading="lazy"/>
    </TsMediaStart>
    <TsMediaContent :appendClass="twMerge('my-auto ml-2 flex-1',props.contentContainer)">
      <TsTypography variant="h3" :append-class="twMerge('mb-0')" weight="bold" :data-testid="`${props.dataTestid}-title`">{{ props.title }}</TsTypography>
      <TsTypography :append-class="twMerge('mb-0 max-w-72',props.contentClass)" :data-testid="`${props.dataTestid}-description`">
        <span v-html="props.description"></span>
      </TsTypography>
      <a v-if="props.button" :href="`tel:${props.button.number}`">
        <TsButton v-bind="props.button" appendClass="mt-4" size="sm" :label="props.button.label" :icon="props.button.icon" :data-testid="`${props.dataTestid}-button`"/>
      </a>
    </TsMediaContent>
  </TsMedia>
</template>

<script lang="ts" setup>
import { twMerge } from "tailwind-merge";
import { useRandomUUID } from "~/composables/useRandomUUID";
import { onMounted, ref } from "vue";


const TsMediaStart = defineAsyncComponent(
    () => import('~/components/organisms/TsMediaStart.vue')
);

const TsMediaContent = defineAsyncComponent(
    () => import('~/components/organisms/TsMediaContent.vue')
);


// random ID for each Vue Instance
const randomId = ref<string>("");

onMounted(() => {
  randomId.value = useRandomUUID();
});

type Props = {
  button?: Record<string, any> | null
  img?: string,
  title?: string,
  description?: string,
  altText?: string,
  reverseLayout?: boolean,
  dataTestid?: string,
  height?: string,
  width?: string,
  mobileHeight?: string,
  mobileWidth?: string,
  variant?: string,
  contentClass?: string,
  contentContainer?: string,
  appendClass?: string
}

const props = withDefaults(defineProps<Props>(), {
  img: "/images/contactCity.png",
  title: "Still have questions?",
  description: "Can't find the answers you're looking for?",
  altText: "contact img",
  height: "300",
  width: "232",
  mobileHeight: "148",
  mobileWidth: "153"
});
</script>
